import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const TracksIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '70%' : '100%'}
      height={circled ? '70%' : '100%'}
      viewBox="0 0 26.5 18.552"
    >
      <defs>
        <clipPath>
          <rect width="26.5" height="18.552" transform="translate(0 0)" fill="none" />
        </clipPath>
      </defs>
      <g transform="translate(0 0)">
        <g clipPath="url(#clipPath)">
          <path
            d="M13.25.75.75,9.276,13.25,17.8l12.5-8.526Z"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
      <line
        x2="12.516"
        y2="8.368"
        transform="translate(4.762 6.539)"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        y1="8.452"
        x2="12.392"
        transform="translate(4.45 3.273)"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        y1="8.452"
        x2="12.392"
        transform="translate(9.091 6.442)"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x2="12.506"
        y2="8.361"
        transform="translate(9.227 3.599)"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  </CircledIcon>
);
